import React, { useState, useEffect } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import { Link } from 'react-router-dom';
import { AiOutlinePlus, AiFillEdit, AiFillDelete } from 'react-icons/ai'
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { AiOutlineRollback } from "react-icons/ai";
import { useHistory } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { useParams } from 'react-router-dom';
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import 'bootstrap/dist/css/bootstrap.min.css';
import { defaultConf } from "../config/DefaultConf";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import ReactPaginate from "react-paginate";

function Editgeneral() {
  const history = useHistory();
  const [dataDetails, setDataDetails] = useState([]);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState([]);
  const [validated, setValidated] = useState(false);
  const [fileList, setFileList] = useState([])
  const [fullscreen, setFullscreen] = useState(true);
  const [pageFile, setPageFile] = useState(1);
  const [limitFile, setLimitFile] = useState(15);
  const [pagesFile, setPagesFile] = useState(0);
  const [rowsFile, setRowsFile] = useState(0);
  const [modalShow, setModalShow] = React.useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const filePath = defaultConf.uploadUrl;
  const [formData, setFormData] = useState({
      name: '',
      gedung: '',
      alamat: '',
      phoneNumber: '',
      phoneNumber2: '',
      mobilePhone: '',
      email: '',
      website: '',
      facebook: '',
      instagram: '',
      linkedin: '',
      copyright: '',
      maps: '',
      banner: '',
      companyProfile: '',
  });

  useEffect(() => {
      getDetails()
  }, []);
  
  function getDetails(e) {
      Api().get(`generals`)
      .then((response) => response)
      .then((data) => {
          setDataDetails(data.data);
      })
      .catch((err) => {
      });
  }

  function handleChange(e) {
      const key = e.target.name;
      const value = e.target.value;
      setFormData({...formData, [key]: value})
  }

  const handleSubmit = async (req, res) => {
      req.preventDefault();
      setError(null);
      const form = req.currentTarget;
      if (form.checkValidity() === false) {
          req.preventDefault();
          req.stopPropagation();
      }
      setValidated(true);
      var data = new FormData(form);
      let formObject = Object.fromEntries(data.entries());
      console.log('formObject', formObject);
      await Api().patch(`generals`, formObject)
      .then((response) => response)
      .then((data) => {
          if( data.status === 201 || data.status === 200 ){
              history.push('/general');
          }
      })
      .catch((err) => {
      });
  };

  
      
    const getFileList = async (type, pageNum=pageFile, limitNum=limitFile) => {
			var url = `files?page=${pageNum}&limit=${limitNum}`
      if(type === 'Document')
			{
				url = url + '&fields=folder&filter=documents'
			}
      await Api().get(`${url}`)
      .then((response) => response)
      .then((responseFiles) => {
        console.log(responseFiles)
        const listFiles = responseFiles.data;
        setFileList(listFiles.docs);
        setPageFile(listFiles.page);
        setPagesFile(listFiles.totalPages);
        setRowsFile(listFiles.totalDocs);
        setModalShow(true)
      })
      .catch((err) => {
      })
    }
  
    const changePageFile = ({ selected }) => {
      console.log(selected)
      setFileList([])
      setPageFile(selected+1);
      getFileList(selected+1);
    }
  
    
    
    const handleSetImage = async (e) => {
      // e.preventDefault();
      const idFile = e.target.attributes.getNamedItem("data-id").value
      const type = e.target.attributes.getNamedItem("data-type").value
			const payload = {
        type: "General",
      };
			if(type==='Document')
			{
      	setFormData({...formData, ['companyProfile']: idFile})
				payload.companyProfile = idFile
			}
			else
			{
      	setFormData({...formData, ['banner']: idFile})
				payload.banner = idFile
			}
  
      
  
      await Api().put(`files/cover/${dataDetails._id}`, payload)
      .then((response) => response)
      .then((res) => {
        console.log(res)
        if( res.status === 200 ){
          getDetails();
          handleCloseModal()
        }
      })
      .catch((err) => {
          
      });
    }
    
    const handleOpenFiles = async (e) => {
      e.preventDefault();
      const id = e.target.attributes.getNamedItem("data-id").value
      const type = e.target.attributes.getNamedItem("data-type").value
      setSelectedType(type)
      setSelectedProject(id)
      setFullscreen(true)
      getFileList(type)
    }
  
    const handleCloseModal = () => {
      setModalShow(false)
      setPageFile(1);
      setPagesFile(0);
      setRowsFile(0);
    }

    return (
        <>
            <div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
                <DefaultLayout />
                {/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
                <main>
                    <div className="content-header">
                        <Container fluid>
                            <Row className="">
                                <Col sm={4}>
                                <h1 className="m-0">Edit General</h1>
                                </Col>
                                <Col sm={2}>
                                    { checkMenu('modules') &&
                                        <Link to="/general"><Button variant="outline-primary" className="btn-upload"><AiOutlineRollback /> Back</Button></Link>
                                    }
                                </Col>
                                <Col sm={3}>
                                </Col>
                                <Col sm={3}>
                                <div className="date-time float-sm-right">
                                    { moment().format('dddd, DD MMMM YYYY') }
                                </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                        
                    <div className="content">
                        <Container fluid>
                            <Row>
                                <Col lg={12}>
                                    <Card className="content-list">
                                        <Card.Body>
                                            <Col md="6">
                                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                                    <Row className="mb-3">
                                                      <Form.Group as={Col} md="4" controlId="validationCustom08">
                                                        <Form.Label>Banner</Form.Label><br />
                                                        {dataDetails.banner !== null &&
                                                          <>
                                                            <img src={filePath + dataDetails.banner?.uploadFile} width={300}/><br /><br />
                                                          </>
                                                        }
                                                        <input type="hidden" name="banner" defaultValue={dataDetails.banner?._id || formData.banner} />
                                                        <Button type="button" onClick={handleOpenFiles} data-id={dataDetails._id} data-type="Banner">{dataDetails.banner === null ? "Select Banner" : "Change Banner"}</Button>
                                                      </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <input type="hidden" name="id" defaultValue={dataDetails._id} />
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Name</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Name"
                                                                name="name"
                                                                defaultValue={dataDetails.name || formData.name}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                            <Form.Label>Email</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="example : info@kogas.co.id"
                                                                name="email"
                                                                defaultValue={dataDetails.email || formData.email}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Website</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Website"
                                                                name="website"
                                                                defaultValue={dataDetails.website || formData.website}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Copyright</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Copyright"
                                                                name="copyright"
                                                                defaultValue={dataDetails.copyright || formData.copyright}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Phone</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Phone"
                                                                name="phoneNumber"
                                                                defaultValue={dataDetails.phoneNumber || formData.phoneNumber}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Phone</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Phone 2"
                                                                name="phoneNumber2"
                                                                defaultValue={dataDetails.phoneNumber2 || formData.phoneNumber2}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Mobilephone</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Mobilephone"
                                                                name="mobilePhone"
                                                                defaultValue={dataDetails.mobilePhone || formData.mobilePhone}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Building Name</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Building Name"
                                                                name="gedung"
                                                                defaultValue={dataDetails.gedung || formData.gedung}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Address</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="textarea"
                                                                placeholder="Address"
                                                                name="alamat"
                                                                defaultValue={dataDetails.alamat || formData.alamat}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Facebook</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Facebook"
                                                                name="facebook"
                                                                defaultValue={dataDetails.facebook || formData.facebook}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Instagram</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Instagram"
                                                                name="instagram"
                                                                defaultValue={dataDetails.instagram || formData.instagram}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>LinkedIn</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="LinkedIn"
                                                                name="linkedin"
                                                                defaultValue={dataDetails.linkedin || formData.linkedin}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                            <Form.Label>Maps</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Maps"
                                                                name="maps"
                                                                defaultValue={dataDetails.maps || formData.maps}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback>Validate!</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-3">
                                                      <Form.Group as={Col} md="4" controlId="validationCustom08">
                                                        <Form.Label>Company Profile</Form.Label><br />
                                                        {dataDetails.companyProfile !== null &&
                                                          <>
                                                            <a target='_blank' href={filePath + dataDetails.companyProfile?.uploadFile} width={300}>{dataDetails.companyProfile?.filename}</a><br /><br />
                                                          </>
                                                        }
                                                        <input type="hidden" name="companyProfile" defaultValue={dataDetails.companyProfile?._id || formData.companyProfile} />
                                                        <Button type="button" size="sm" onClick={handleOpenFiles} data-id={dataDetails._id} data-type="Document">{dataDetails.companyProfile === null ? "Select Compro" : "Change Compro"}</Button>
                                                      </Form.Group>
                                                    </Row>
                                                    {error && 
                                                        <Alert variant="danger">
                                                            {error}
                                                        </Alert>
                                                    }
                                                    
                                                    <Button type="submit" size='lg'>Save</Button>
                                                </Form>
                                            </Col>
                                            
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </main>
            </div>
            <Footer />
            
            <Modal 
              show={modalShow} 
              fullscreen={fullscreen} 
              onHide={handleCloseModal}
              dialogClassName="modal-full-custom"
              scrollable={fullscreen}
            >
              <Modal.Header closeButton>
                <Modal.Title className='text-center'>
                  Set {selectedType === 'Document' ? 'Company Profile' : 'Banner'}
                </Modal.Title>
              </Modal.Header>
              {/* <Modal.Header style={{display: "block"}}>
              </Modal.Header> */}
              <Modal.Body>
                <Container fluid>
                  <Row xs={5} md={5} lg={5} className="g-2">
                    {
                      fileList.map((item, i) => (
                        <Col key={i}>
                          <Card>
														{item.mimetype === 'application/pdf' ?
																<>
																	<Card.Text variant="top">{item.filename}</Card.Text>
																	<Card.Body>
																		<Button variant="primary" data-id={item._id} data-type="Document" onClick={handleSetImage}>Choose This</Button>
																	</Card.Body>
																</>
															:
																<>
																	<Card.Img variant="top" src={filePath + item.uploadFile} />
																	<Card.Body>
																		<Button variant="primary" data-id={item._id} data-type="Banner" onClick={handleSetImage}>Choose This</Button>
																	</Card.Body>
																</>
																
														}
                            
                            
                          </Card>
                        </Col>
                      ))
                    }
                  </Row>
                </Container>
                
              </Modal.Body>
              <Modal.Footer>
                <Container fluid>
                  <Row>
                    <Col lg={3} md={4}>
                      <p>Total Data: {rowsFile} Page: {rowsFile ? pageFile : 0} of {pagesFile}</p>
                    </Col>
                    <Col lg={9} md={8}>
                      <nav
                        className="pagination float-sm-right"
                        key={rowsFile}
                        role="navigation"
                        aria-label="pagination"
                      >
                        <ReactPaginate
                          previousLabel={"< Prev"}
                          nextLabel={"Next >"}
                          pageCount={pagesFile}
                          onPageChange={changePageFile}
                          containerClassName={"pagination-list pagination"}
                          pageLinkClassName={"pagination-link page-link"}
                          previousLinkClassName={"pagination-previous page-link"}
                          nextLinkClassName={"pagination-next page-link"}
                          activeLinkClassName={"pagination-link is-current"}
                          disabledLinkClassName={"pagination-link is-disabled"}
                          activeClassName={"active"}
                          pageClassName={"page-item"}
                        />
                      </nav>
                    </Col>
                  </Row>
                </Container>
              </Modal.Footer>
            </Modal>
        </>
    )
}
export default Editgeneral